import { boardsSl } from "./boards.ts";
// Slovenian catalog. Same keys as en.ts. Informal 2nd-person singular ("ti").
// Plural entries carry one/two/few/other (CLDR). See DESIGN §5.3/§5.4.

type Entry = string | { one: string; two?: string; few?: string; other: string };

export const sl: Record<string, Entry> = {
  "native.signIn": "Prijavite se za povezavo s ChessME.",
  "native.title": "Povežite ChessME za iOS",
  "native.account": "Nadaljujete kot {name}.",
  "native.intro": "Aplikacija se poveže s tem računom, da lahko igre iz Sporočil nadaljujete na spletu.",
  "native.continue": "Nadaljuj kot {name}",
  "native.switch": "Uporabi drug račun",
  "native.expired": "Prijava je potekla. Začnite znova v ChessME.",
  "native.failed": "Prijava ni uspela.",
  "native.invalid": "Neveljaven povratni naslov aplikacije.",
  "native.return": "Nazaj v ChessME",
  "native.restart": "Začnite znova v ChessME.",
  "continuation.loadFailed": "Vabila ni bilo mogoče naložiti.",
  "continuation.selected": "Izbrani položaj iz Sporočil",
  "continuation.history": "Zgodovina potez iz Sporočil",
  "continuation.title": "Nadaljuj na spletu",
  "continuation.intro": "Nadaljuj iz tega položaja iz Sporočil brez ure in sprememb ratinga.",
  "continuation.copies": "Druge kopije v Sporočilih lahko ostanejo igralne. Z nasprotnikom se dogovorita, da od tu naprej uporabljata spletno partijo.",
  "continuation.back": "Nazaj na ChessME",
  "continuation.recoverStorage": "Brskalnik ni mogel obnoviti shranjenega dejanja. Pred potrditvijo se znova prijavi in ohrani obstoječe vabilo v Sporočilih.",
  "continuation.badPosition": "Izvornega položaja ni bilo mogoče pregledati.",
  "continuation.badHistory": "Izvorne zgodovine ni bilo mogoče pregledati.",
  "continuation.start": "Začetek",
  "continuation.waiting": "Čakanje na nasprotnika",
  "continuation.signIn": "Prijavi se za pregled in nadaljevanje",
  "continuation.open": "Odpri spletno partijo",
  "continuation.saved": "Nadaljevanje je shranjeno. Odpreš isto partijo z isto zgodovino.",
  "continuation.checking": "Preverjanje shranjenega dejanja …",
  "continuation.check": "Preveri shranjeno dejanje",
  "continuation.signAgain": "Znova se prijavi",
  "continuation.unknown": "Preverjamo zadnje dejanje. Pred pošiljanjem novega dejanja bomo obnovili njegov izid.",
  "continuation.expired": "Vabilo je poteklo brez začetka partije. Prosi za novo vabilo.",
  "continuation.cancelled": "Vabilo je bilo preklicano.",
  "continuation.share": "Deli vabilo, nato potrdi račun igralca, ki ga sprejme.",
  "continuation.waitApproval": "Čakamo, da pošiljatelj vabila potrdi tvoj račun.",
  "continuation.withdraw": "Umakni potrditev",
  "continuation.consent": "Prepoznam to zgodovino in razporeditev barv ter soglašam z nadaljevanjem na spletu.",
  "continuation.ready": "Pripravljen na spletno igro",
  "continuation.link": "Povezava do vabila za nasprotnika",
  "continuation.extend": "Podaljšaj vabilo",
  "continuation.cancel": "Prekliči vabilo",
  "continuation.existing": "Odpri obstoječe nadaljevanje",
  "continuation.private": "Partija je na voljo le njenima igralcema. Prijavi se z računom, uporabljenim za vabilo.",
  "continuation.account": "Uporabi drug račun",
  "continuation.logoutFailed": "Odjava ni uspela. Poskusi znova.",
  "continuation.saveFailed": "Brskalnik ni mogel shraniti dejanja. Pred potrditvijo omogoči shranjevanje podatkov spletnega mesta.",
  "continuation.recorded": "Dejanje je shranjeno. Pred novo potrditvijo čakamo na trenutno stanje vabila.",
  "continuation.lostResponse": "Odgovor ni prispel. Preverjanje shranjenega dejanja ohrani isto vabilo in partijo.",
  "continuation.refreshFailed": "Vabila ni bilo mogoče osvežiti. Potrjevanje počaka, dokler stanje ni na voljo.",
  "continuation.capacity": "Vse spletne deske so zasedene. Oba igralca lahko pozneje znova potrdita pripravljenost.",
  "continuation.busy": "Eden od vaju že igra aktivno partijo. Končajta jo ali začasno prekinita, nato oba znova potrdita.",
  "continuation.closed": "Začetek spletnih partij je začasno ustavljen. Vabilo ostaja shranjeno.",
  "continuation.changed": "Vabilo se je spremenilo. Znova preglej položaj in barvi.",
  "continuation.approval": "Pošiljatelj vabila mora pred začetkom potrditi nasprotnika.",
  "continuation.sourceConflict": "Ta partija iz Sporočil že ima spletno nadaljevanje. Odpri ga spodaj.",
  "continuation.inviterCancelled": "Pošiljatelj je preklical vabilo.",
  "continuation.waitReady": "Čakanje na potrditev drugega igralca.",
  "continuation.claimed": "Tvoj račun je povezan z vabilom. Preglej trenutne podatke.",
  "continuation.renewLimit": "Vabila ni mogoče znova podaljšati. Po poteku ustvari novo vabilo.",
  "continuation.failed": "Dejanja ni bilo mogoče dokončati. Pred novim poskusom preglej trenutno vabilo.",
  "continuation.journal": "Shranjeno dejanje je treba obnoviti. Ohrani ta zavihek odprt in se znova prijavi.",
  "continuation.legacy": "Za to vabilo je bila izbrana starejša kopija iz Sporočil. Druge kopije se lahko razlikujejo.",
  "continuation.included": "Vključenih potez iz Sporočil: {n}.",
  "continuation.invitedBy": "Vabi te {name}, ki igra z barvo: {color}.",
  "continuation.signedIn": "Prijavljen kot {name}.",
  "continuation.claimAs": "Nadaljuj kot {name}",
  "continuation.confirmOpponent": "Potrdi igralca {name} kot nasprotnika",
  "continuation.confirmSeconds": "Tvoja potrditev velja še {n} sekund. Čakamo na drugega igralca.",
  "continuation.past": "Zgodovina iz Sporočil po {n} potezah",
  "continuation.context": "V Sporočilih je bilo dovoljeno: {features}. Spletna partija ostane brez ratinga.",
  "continuation.undo": "razveljavljanje potez",
  "continuation.assistance": "pomoč",
  "continuation.and": " in ",
  "continuation.wrongAccount": "Dejanje pripada računu {name}. Prijavi se s tem računom za preverjanje stanja.",
  "game.enterMove": "Vnesi potezo s tipkovnico",
  "game.moveNotation": "Poteza v zapisu SAN ali s koordinatami",
  "game.playMove": "Odigraj potezo",
  "game.invalidTypedMove": "Vnesi veljavno potezo, na primer Nf3 ali g1f3. Pri promociji navedi figuro, na primer e8=Q ali e7e8q.",
  "game.boardStatus": "Na potezi: {turn}. Igraš: {color}. {status}.",
  "game.finished": "Partija je končana",
  "game.inMessages": "Partija se nadaljuje v Sporočilih",
  "mode.live": "Igraj v živo",
  "mode.messages": "Igraj v Sporočilih",
  "mode.messagesHelp": "Na iPhonu ali iPadu odpri ChessME v pogovoru v Sporočilih in izmenjuj poteze s prijateljem.",
  "direct.title": "Povabi nekoga k igri",
  "direct.body": "Izberi igro, nato povezavo deli z nasprotnikom. Igra se začne, ko sprejme vabilo.",
  "direct.create": "Ustvari povezavo do igre",
  "direct.ready": "Povezava do vabila je pripravljena.",
  "email.title": "Nadaljuj z e-pošto",
  "email.public": "Si nov tukaj? Koda ustvari račun. Obstoječi igralci obdržijo svoj račun in igre.",
  "email.existing": "Uporabi e-poštni naslov svojega obstoječega računa.",
  "email.address": "E-poštni naslov",
  "email.sent": "Preveri kodo na naslovu {email}.",
  "email.instructions": "Če je naslov upravičen, bo koda kmalu prispela. Velja pet minut. Uporabi zadnjo zahtevano kodo.",
  "email.resend": "Pošlji novo kodo",
  "email.resendIn": "Nova koda čez {seconds} s",
  "email.change": "Uporabi drug e-poštni naslov",
  "email.inviteTitle": "Prijavi se za pregled vabila",
  "email.inviteBody": "Potrdi svoj e-poštni naslov, nato se vrni in izberi, ali želiš igrati.",
  // --- common / chess vocabulary ---
  "common.cancel": "Prekliči",
  "common.confirm": "Potrdi",
  "common.ok": "V redu",
  "common.save": "Shrani",
  "common.delete": "Izbriši",
  "common.loadFailed": "Nalaganje ni uspelo — poskusi znova.",
  "common.home": "Domov",
  "common.loading": "Nalagam…",
  "common.sending": "Pošiljam…",
  "common.saving": "Shranjujem…",
  "common.redirecting": "Preusmerjam…",
  "common.openingGame": "Odpiram partijo…",
  "common.backHome": "Nazaj domov",
  "common.somethingWrong": "Nekaj je šlo narobe.",
  "common.you": "Ti",
  "chess.white": "Beli",
  "chess.black": "Črni",
  "chess.random": "Naključno",
  "chess.rated": "rangirano",
  "chess.casual": "prijateljsko",
  "chess.ratedCap": "Rangirano",
  "chess.blitz": "Blitz",
  "chess.rapid": "Rapid",
  "chess.timeControl": "Časovni nadzor",
  "chess.yourColor": "Tvoja barva",
  "chess.computer": "Računalnik",
  "plural.games": { one: "{n} partija", two: "{n} partiji", few: "{n} partije", other: "{n} partij" },
  "plural.moves": { one: "{n} poteza", two: "{n} potezi", few: "{n} poteze", other: "{n} potez" },
  "plural.members": { one: "{n} član", two: "{n} člana", few: "{n} člani", other: "{n} članov" },
  "plural.positions": { one: "{n} pozicija", two: "{n} poziciji", few: "{n} pozicije", other: "{n} pozicij" },

  // --- nav / topnav ---
  "nav.primary": "Glavna navigacija",
  "nav.play": "Igraj",
  "nav.players": "Igralci",
  "nav.games": "Partije",
  "nav.study": "Študij",
  "nav.activity": "Aktivnost",
  "nav.admin": "Skrbništvo",
  "nav.profileTitle": "Profil in nastavitve",

  // --- login + private-club + membership ---
  "login.tagline": "Zasebni spletni šahovski klub — igraš na povabilo.",
  "login.loginLabel": "Uporabniško ime ali e-pošta",
  "login.password": "Geslo",
  "login.signIn": "Prijavi se",
  "login.signingIn": "Prijavljam…",
  "login.needBoth": "Vnesi uporabniško ime ali e-pošto in geslo.",
  "login.couldNot": "Prijava ni uspela.",
  "login.forgot": "Si pozabil geslo?",
  "login.useCode": "Prijava z enkratno kodo",
  "login.usePassword": "Uporabi geslo",
  "login.codeProvider": "Pošlji kodo prek",
  "login.sendCode": "Pošlji prijavno kodo",
  "login.sendingCode": "Pošiljam kodo…",
  "login.codeLabel": "Šestmestna koda",
  "login.verifyCode": "Preveri in se prijavi",
  "login.codeNeed": "Vnesi šestmestno kodo.",
  "login.codeFailed": "Kode ni bilo mogoče poslati ali preveriti.",
  "login.inviteOnlyLead": "Še nimaš računa?",
  "login.inviteOnly": "ChessME je samo na povabilo — prosi člana za izziv ali zaprosi za članstvo.",
  "login.becomeMember": "Postani član",
  "join.title": "Zaprosi za članstvo",
  "join.intro": "ChessME je majhen klub, samo na povabilo. Povej nam nekaj o sebi in poslali ti bomo povabilo. Članstvo je brezplačno.",
  "join.name": "Tvoje ime",
  "join.email": "Tvoja e-pošta",
  "join.emailHelp": "Sem ti bomo poslali povabilo.",
  "join.experience": "Šahovske izkušnje",
  "join.experienceOpt": "Neobvezno — npr. začetnik, klubski igralec, približni rating.",
  "join.message": "Bi rad kaj dodal?",
  "join.messageOpt": "Neobvezno — kje si slišal za nas ali koga poznaš v klubu.",
  "join.submit": "Pošlji prošnjo",
  "join.sending": "Pošiljam…",
  "join.needName": "Vnesi svoje ime.",
  "join.needEmail": "Vnesi veljavno e-pošto.",
  "join.success": "Hvala! Tvojo prošnjo smo prejeli in kmalu ti bomo po e-pošti poslali povabilo.",
  "join.failed": "Prošnje ni bilo mogoče poslati. Poskusi znova.",
  "join.back": "← Nazaj na prijavo",

  // --- forgot / reset ---
  "forgot.tagline": "Si pozabil geslo? Ni panike — po e-pošti ti pošljemo povezavo za ponastavitev.",
  "forgot.label": "Uporabniško ime ali e-pošta",
  "forgot.submit": "Pošlji mi povezavo",
  "forgot.back": "Nazaj na prijavo",
  "forgot.need": "Vnesi uporabniško ime ali e-pošto.",
  "forgot.sending": "Pošiljam…",
  "forgot.sent": "Če ta račun obstaja, je povezava za ponastavitev na poti. Preveri e-pošto — poteče čez eno uro.",
  "forgot.failed": "Povezave ni bilo mogoče poslati.",
  "reset.tagline": "Izberi novo geslo.",
  "reset.label": "Novo geslo",
  "reset.submit": "Nastavi geslo in se prijavi",
  "reset.min": "Geslo mora imeti vsaj 8 znakov.",
  "reset.saving": "Shranjujem…",
  "reset.failed": "Gesla ni bilo mogoče ponastaviti.",

  // --- onboard (invite-accept) ---
  "onboard.headline": "{who} te izziva na {tc} ({kind}) partijo.",
  "onboard.aFriend": "Prijatelj",
  "onboard.signupIntro": "Ustvari račun za {email} in se takoj pridruži.",
  "onboard.username": "Uporabniško ime",
  "onboard.password": "Geslo",
  "onboard.createPlay": "Ustvari račun in igraj",
  "onboard.needUser": "Izberi uporabniško ime z vsaj 3 znaki.",
  "onboard.needPass": "Geslo mora imeti vsaj 8 znakov.",
  "onboard.creating": "Ustvarjam račun…",
  "onboard.signedInAs": "Prijavljen kot {who}.",
  "onboard.acceptPlay": "Sprejmi in igraj",
  "onboard.decline": "Zavrni",
  "onboard.notNow": "Ne zdaj — nazaj domov",
  "onboard.accepting": "Sprejemam…",
  "onboard.declining": "Zavračam…",
  "onboard.declined": "Zavrnjeno — {who} je obveščen.",
  "onboard.cantAccept": "Sprejem ni uspel.",
  "onboard.cantDecline": "Zavrnitev ni uspela.",
  "onboard.welcomeBack": "Dobrodošel nazaj, {who} — vnesi geslo za sprejem.",
  "onboard.signinPlay": "Prijavi se in igraj",
  "onboard.needPassword": "Vnesi geslo.",
  "onboard.signingYouIn": "Prijavljam…",
  "onboard.notFoundTitle": "Povabila ni mogoče najti",
  "onboard.brokenLink": "Ta povezava je videti pokvarjena.",
  "onboard.acceptedTitle": "Že sprejeto",
  "onboard.acceptedBody": "Ta izziv je že sprejet. Prijavi se za nadaljevanje.",
  "onboard.expiredTitle": "Povabilo je poteklo",
  "onboard.expiredBody": "Prosi prijatelja za nov izziv.",
  "onboard.unavailTitle": "Povabilo ni na voljo",
  "onboard.unavailBody": "Ta izziv ni več odprt.",

  // --- invite (member → email invite) ---
  "invite.title": "Povabi novega igralca",
  "invite.tagline": "Prejeli bodo izziv po e-pošti in se pridružili naravnost v partijo — brez predhodnega računa.",
  "invite.theirEmail": "Njihova e-pošta",
  "invite.ping": "Obvesti me, ko bodo pripravljeni na igro",
  "invite.send": "Pošlji izziv",
  "invite.orMember": "← Ali izzovi člana, ki ga že poznaš",
  "invite.needEmail": "Vnesi prijateljev e-naslov.",
  "invite.sentTo": "✓ Izziv poslan na {email}.",
  "invite.shareLink": "Če želiš, deli povezavo neposredno:",
  "invite.failed": "Povabila ni bilo mogoče poslati.",

  // --- home ---
  "home.challengesForYou": "Izzivi zate",
  "home.continuePlaying": "Nadaljuj igro",
  "home.play": "Igraj",
  "home.recentResults": "Nedavni rezultati",
  "home.allGames": "Vse partije →",
  "home.playFriend": "♟ Igraj s prijateljem",
  "home.playComputer": "🤖 Igraj z računalnikom",
  "home.inviteEmail": "+ Povabi novega po e-pošti",
  "home.challengesYou": "{who} te izziva",
  "home.accept": "Sprejmi →",
  "home.incomingMore": "Prikazanih je tvojih 20 najnovejših izzivov — sprejmi nekaj, da vidiš ostale.",
  "home.vs": "proti {who}",
  "home.resume": "nadaljuj",
  "home.recentComputer": "Nedavne partije z računalnikom",
  "home.vsComputerL": "proti računalniku · S{level}",
  "home.playAgainTitle": "Ponovno igraj proti {who}",
  "home.cantChallenge": "Izziva ni bilo mogoče poslati.",
  "home.paused": "Premor · Odpri partijo",
  "result.won": "zmaga",
  "result.lost": "poraz",
  "result.draw": "remi",
  "result.aborted": "prekinjena",
  "result.playing": "v teku",
  "result.returned": "v Sporočilih",

  // --- waiting room ---
  "waiting.brokenLink": "Ta povezava za povabilo je videti pokvarjena.",
  "waiting.expired": "To povabilo je poteklo.",
  "waiting.noLongerOpen": "Ta izziv ni več odprt.",
  "waiting.yourFriend": "tvoj prijatelj",
  "waiting.forOpponent": "Čakam nasprotnika…",
  "waiting.waiting": "Čakam",
  "waiting.on": "Čakam {who}",
  "waiting.tagline": "Pridružili se bodo takoj, ko sprejmejo. Lahko odideš — izziv je shranjen in ob začetku te bo samodejno vrnilo v partijo.",
  "waiting.ready": "Pripravljen sem — podrezaj jih",
  "waiting.leave": "Odidi — nazaj domov",
  "waiting.nudged": "{who} je na spletu — podrezali smo jih.",
  "waiting.emailed": "{who} smo po e-pošti sporočili, da si pripravljen.",
  "waiting.willLet": "{who} bomo obvestili, ko jih bomo lahko dosegli.",
  "waiting.nudgeFailed": "Podrezavanja ni bilo mogoče poslati.",
  "waiting.expiredPoll": "To povabilo je poteklo.",

  // --- players + directory + leaderboard ---
  "players.directory": "Imenik",
  "players.leaderboard": "Lestvica",
  "players.gameOptions": "Možnosti igre: ",
  "players.inviteEmail": "+ Povabi novega po e-pošti",
  "players.empty": "Zaenkrat ni drugih članov — povabi koga za začetek.",
  "players.loadFailed": "Imenika članov ni bilo mogoče naložiti.",
  "players.recentlyPlayed": "Nedavno igrano:",
  "players.challengeName": "Izzovi {who}",
  "players.online": "na spletu",
  "players.offline": "brez povezave",
  "players.play": "Igraj",
  "players.unrated": "brez ratinga",
  "players.searchLabel": "Iskanje članov",
  "players.searchPlaceholder": "Poišči člana po imenu…",
  "players.searchEmpty": "Noben član ne ustreza »{q}«.",
  "players.onlineNow": "Zdaj prisotni:",
  "players.lbTagline": "Rating Glicko-2 po hitrosti. »?« označuje začasni rating.",
  "players.lbFailed": "Lestvice ni bilo mogoče naložiti.",
  "players.noRated": "Zaenkrat ni rangiranih {speed} partij.",

  // --- player profile + settings ---
  "player.loadFailed": "Tega igralca ni bilo mogoče naložiti.",
  "player.players": "Igralci",
  "player.challengeName": "Izzovi {who}",
  "player.sendingChal": "Pošiljam izziv…",
  "player.cantChallenge": "Izziva ni bilo mogoče poslati.",
  "player.cantReach": "Izzoveš lahko le člane, s katerimi si v isti skupini. Prosi skrbnika, da vaju doda v skupno skupino.",
  "player.h2h": "Medsebojni izid",
  "player.h2hEmpty": "S {who} še nisi igral.",
  "player.youWon": "tvoje zmage",
  "player.drawn": "remiji",
  "player.youLost": "tvoji porazi",
  "settings.title": "Nastavitve",
  "settings.boardTheme": "Tema šahovnice",
  "settings.appearance": "Videz",
  "settings.analysisDepth": "Globina analize",
  "settings.analysisDepthHelp":
    "Kako trdo dela motor na analizni deski. »Neomejeno« nenehno premišljuje o položaju, ki ga gledaš, in izostruje oceno, dokler je ta na zaslonu.",
  "settings.save": "Shrani",
  "settings.signOut": "Odjava",
  "settings.saved": "Shranjeno.",
  "settings.saveFailed": "Shranjevanje ni uspelo.",
  "settings.providerEmail": "E-pošta",
  "settings.openTelegram": "Odpri Telegram",
  "theme.appearance": "Videz",
  "theme.system": "Sistem",
  "theme.light": "Svetla",
  "theme.dark": "Temna",
  "theme.systemLabel": "Tema: sistem",
  "theme.lightLabel": "Tema: svetla",
  "theme.darkLabel": "Tema: temna",
  "board.green": "Zelena",
  "board.brown": "Rjava",
  "board.blue": "Modra",
  "board.pickerLabel": "Tema šahovnice",
  "premove.label": "Vnaprejšnja poteza",
  "premove.help": "Pripravi potezo med nasprotnikovim potezom; izvede se samodejno, ko odigra.",
  "depth.fast": "Hitro",
  "depth.balanced": "Uravnoteženo",
  "depth.deep": "Globoko",
  "depth.unlimited": "Neomejeno",
  "depth.plies": "globina {n}",
  "depth.keepsThinking": "nenehno računa",

  // --- history ---
  "history.title": "Tvoje partije",
  "history.exportAll": "Izvozi vse (.pgn)",
  "history.timeHorizon": "Časovni okvir",
  "history.thisWeek": "Ta teden",
  "history.thisMonth": "Ta mesec",
  "history.all": "Vse",
  "history.loadMore": "Naloži več",
  "history.emptyAll": "Zaenkrat ni partij — povabi prijatelja ali igraj z računalnikom.",
  "history.emptyRange": "V tem obdobju ni partij.",
  "history.loadFailed": "Tvojih partij ni bilo mogoče naložiti.",
  "history.exporting": "Izvažam…",
  "history.exportCapped": "Izvoženih {cap} najnovejših partij — v tem obdobju jih je še več, a niso vključene. Zoži časovni okvir za izvoz ostalih.",
  "history.exportFailed": "Partij ni bilo mogoče izvoziti — poskusi znova.",
  "history.downloadPgn": "Prenesi PGN",

  // --- activity ---
  "activity.title": "Aktivnost",
  "activity.tagline": "Izzivi, ki si jih poslal, najnovejši najprej.",
  "activity.empty1": "Zaenkrat še nisi poslal nobenega izziva. ",
  "activity.challengeSomeone": "Izzovi koga →",
  "activity.loadFailed": "Tvoje aktivnosti ni bilo mogoče naložiti.",
  "activity.atBoard": "za šahovnico",
  "activity.joinNow": "Pridruži se",
  "activity.openGame": "Odpri partijo",
  "status.pending": "v čakanju",
  "status.accepted": "sprejeto",
  "status.declined": "zavrnjeno",
  "status.expired": "poteklo",
  "status.canceled": "preklicano",

  // --- study + collections ---
  "study.importTitle": "Uvozi partijo",
  "study.myStudies": "Moji študiji",
  "study.collections": "Zbirke",
  "study.importHelp": "Prilepi PGN, izberi datoteko .pgn ali preberi iz odložišča. Uvožene partije so shranjene v tem brskalniku.",
  "study.import": "Uvozi",
  "study.chooseFile": "Izberi datoteko",
  "study.fromClipboard": "Iz odložišča",
  "study.nothingToImport": "Ni kaj uvoziti — najprej prilepi ali izberi PGN.",
  "study.noGamesFound": "V tem PGN ni najdenih partij.",
  "study.imported": { one: "Uvožena {n} partija.", two: "Uvoženi {n} partiji.", few: "Uvožene {n} partije.", other: "Uvoženih {n} partij." },
  "study.skipped": "{n} ni bilo mogoče razčleniti",
  "study.droppedByCap": "{n} ni ustrezalo (knjižnica hrani {max})",
  "study.readFailed": "Datoteke ni bilo mogoče prebrati.",
  "study.clipboardFailed": "Odložišča ni bilo mogoče prebrati — prilepi ročno.",
  "study.saveFailed": "Brskalnik teh partij ni mogel shraniti. Nič ni bilo uvoženo; tvoj PGN je še vedno tukaj.",
  "study.emptyStudies": "Zaenkrat ni študijev — uvozi partijo zgoraj za začetek.",
  "study.delete": "Izbriši",
  "openings.title": "Otvoritve",
  "openings.panelHelp": "Vadi 30 uveljavljenih otvoritev z obeh strani: vodeni tečaji z razlago in zgoščena podprta teorija.",
  "openings.openGames": "Odprte igre — 1.e4 e5",
  "openings.openGamesHelp": "Obe strani od prve poteze zasedeta središče",
  "openings.semiOpenGames": "Obrambe proti 1.e4",
  "openings.semiOpenGamesHelp": "Protinapadalni odgovori: 1…c5, 1…c6, 1…e6, 1…d5",
  "openings.closedFlank": "Damin kmet in krilo — 1.d4, 1.c4, 1.Nf3",
  "openings.closedFlankHelp": "Zaprti sistemi in priljubljene izbire mlade elite",
  "openings.start": "Začni",
  "openings.trainAs": "Vadi kot",
  "openings.trainingWhite": "Vadiš z belimi.",
  "openings.trainingBlack": "Vadiš s črnimi.",
  "openings.chooseSide": "Izberi stran za vajo",
  "openings.yourMove": "Tvoja poteza — poišči podprto nadaljevanje.",
  "openings.yourMoveMany": "Tvoja poteza — {n} pregledanih nadaljevanj; vsako nadaljuje lekcijo.",
  "openings.hint": "Namig",
  "openings.showMove": "Pokaži",
  "openings.showSupported": "Pokaži poteze",
  "openings.supportedMoves": "Podprte poteze",
  "openings.supportedHelp": "Podprta nadaljevanja so zdaj prikazana kot gumbi in sive puščice. Izberi eno; nobena poteza ni bila odigrana namesto tebe.",
  "openings.supported": "podprto",
  "openings.supportedOpening": "podprta otvoritev",
  "openings.supportedContinuation": "Uveljavljeno nadaljevanje; podrobna razlaga za to potezo še ni na voljo.",
  "openings.wrong": "Ne čisto — poskusi znova.",
  "openings.notCovered": "{move} je legalna, vendar ni v tukajšnjem skrbno izbranem naboru podprtih potez. Poskusi znova ali prikaži podprte poteze.",
  "openings.expectedMove": "Ciljna poteza je {move}.",
  "openings.mainLine": "Glavna varianta:",
  "openings.newTargetLine": "Cilj je nova nepredelana varianta.",
  "openings.resumeFromFork": "Nadaljuj z drugo nepredelano varianto od najbližjega skupnega razpotja.",
  "openings.linesCovered": "predelanih variant: {n}/{total}",
  "openings.lineCompleteTitle": "Varianta končana",
  "openings.courseCompleteTitle": "Tečaj končan",
  "openings.lineCompleted": "Ta varianta je predelana. Izberi Naslednja veja in nadaljuj.",
  "openings.courseCompleted": "Vse podprte variante so zdaj predelane. Izberi Naslednja veja za ponovitev druge.",
  "openings.continue": "Varianta se nadaljuje.",
  "openings.nextLine": "Naslednja veja",
  "openings.replay": "Ponovi",
  "openings.choiceRank": "izbira {n} od {total}",
  "openings.switchedVariation": "Zamenjava variante — ta veja je zdaj cilj.",
  "openings.opponentReply": "odgovor nasprotnika",
  "openings.candidateMoves": "Kandidatske poteze",
  "openings.candidateHelp": "Tukaj se lahko prikaže eno ali več skrbno izbranih nadaljevanj. Izberi gumb ali odigraj potezo na deski.",
  "openings.candidateHelpBook": "Črtkana poteza vstopi v drugo podprto otvoritev; temu tečaju ne doda napredka.",
  "openings.bookChoice": "raziskovanje knjige",
  "openings.bookCredit": "Teoretska imena in veje:",
  "openings.bookAlternativeHelp": "S tem vstopiš v {opening}, podprto vejo zunaj tega tečaja. Tukaj ne pridobiš napredka; vzemi potezo nazaj ali odpri njeno študijo.",
  "openings.takeBack": "Vzemi nazaj",
  "openings.backInCourse": "Spet si v tem tečaju. Poišči podprto nadaljevanje ali prikaži razpoložljive poteze.",
  "openings.studyOpening": "Študiraj: {opening}",
  "openings.tier.guided": "Vodeno",
  "openings.tier.supported": "Podprto",
  "openings.localProgress": "Napredek pri otvoritvah je shranjen v tem brskalniku in se z računom ne prenese na drugo napravo.",
  "openings.role.primary": "glavna varianta",
  "openings.role.alternative": "pregledana alternativa",
  "openings.role.retry": "poteza za ponovitev",
  "openings.verdict.best": "glavna poteza",
  "openings.verdict.good": "trdna alternativa",
  "openings.verdict.playable": "igralna knjižna poteza",
  "openings.verdict.mistake": "poučna napaka",
  "openings.verdict.unreviewed": "tukaj ni obravnavano",
  "openings.lineUnavailable": "Te variante tečaja ni bilo mogoče odigrati.",
  "openings.playVsComputer": "Proti računalniku",
  "openings.restart": "Začni znova",
  "openings.backToStudy": "Nazaj na Študij",
  "openings.unknownCourse": "Ta tečaj ne obstaja.",
  "collections.classicGames": "Klasične partije",
  "collections.classicGamesHelp": "Javno dostopne briljance romantične dobe",
  "collections.modernGames": "Moderne partije",
  "collections.modernGamesHelp": "Slavne partije zadnjih nekaj desetletij",
  "collections.none": "Ni razpoložljivih zbirk.",
  "collections.notAvail": "Ta zbirka ni na voljo.",
  "collections.notInColl": "Te partije ni v zbirki.",
  "collections.studyBack": "← Študij",
  "collections.emptyColl": "Ta zbirka nima partij.",
  "collections.backToStudy": "Nazaj na Študij",

  // --- computer (play the bot) ---
  "computer.title": "Igraj z računalnikom",
  "computer.strength": "Moč",
  "computer.level": "Stopnja",
  "computer.timeControl": "Časovni nadzor",
  "computer.noClock": "Brez ure",
  "computer.playAs": "Igraj kot",
  "computer.startGame": "Začni partijo",
  "computer.newGame": "Nova partija",
  "computer.resign": "Predaj",
  "computer.resignConfirm": "Predaš to partijo?",
  "computer.you": "Ti",
  "computer.loadingEngine": "Nalagam pogon…",
  "computer.positionReadyLoadingEngine": "Položaj je pripravljen · nalagam pogon…",
  "computer.engineFailed": "Pogona ni bilo mogoče naložiti.",
  "levels.beginner": "začetnik",
  "levels.club": "klub",
  "levels.strong": "močan",
  "levels.maximum": "maksimum",
  "levels.levelN": "Stopnja {n}",
  "levels.levelNq": "Stopnja {n} · {q}",

  // --- game (live game) ---
  "game.loadFailed": "Partije ni bilo mogoče naložiti.",
  "game.offerDraw": "Ponudi remi",
  "game.resign": "Predaj",
  "game.resignConfirm": "Predaš to partijo?",
  "game.saySomething": "Napiši kaj…",
  "game.spectating": "Opazuješ — v tej partiji nisi igralec.",
  "game.online": "Na spletu",
  "game.awayReconnect": "Odsoten — ponovno povezovanje…",
  "game.offline": "Brez povezave",
  "game.connection": "Povezava",
  "game.drawOffered": "Nasprotnik ponuja remi. ",
  "game.accept": "Sprejmi",
  "game.decline": "Zavrni",
  "game.drawWaiting": "Remi ponujen — čakam nasprotnika.",
  "game.continueInMessages": "Nadaljuj v Sporočilih",
  "game.returnAsked": "Nasprotnik želi to partijo nadaljevati v Sporočilih. ",
  "game.returnAgree": "Strinjam se",
  "game.returnNotNow": "Ne zdaj",
  "game.returnWaiting": "Predlagal si nadaljevanje v Sporočilih. Čakam nasprotnika. ",
  "game.returnWithdraw": "Umakni",
  "game.returnRefusedHint": "Nasprotnik želi igrati naprej tukaj. Pred novim predlogom odigraj potezo.",
  "game.returnedHead": "Ta partija se nadaljuje v Sporočilih.",
  "game.returnedBody": "Odpri pogovor v Sporočilih in tapni kartico partije, da nadaljuješ.",
  "game.rematchWaiting": "Revanša ponujena — čakam nasprotnika…",
  "game.rematchWants": "Nasprotnik želi revanšo. ",
  "game.acceptRematch": "Sprejmi revanšo",
  "game.rematchReady": "Revanša pripravljena. ",
  "game.join": "Pridruži se",
  "game.oppLeftClaim": "Nasprotnik je odšel — zahtevaj zmago čez {n}s… ",
  "game.oppLeft": "Nasprotnik je odšel. ",
  "game.claimWin": "Zahtevaj zmago",
  "game.live": "V živo",
  "game.reconnecting": "Ponovno povezovanje…",
  "game.analyze": "Analiziraj",
  "game.rematch": "Revanša",
  "game.challengeAgain": "Izzovi znova",
  "result.youWon": "Zmaga",
  "result.youLost": "Poraz",
  "result.drawWord": "Remi",
  "result.wins": "{who} zmaga",
  "reason.checkmate": "z matom",
  "reason.resignation": "s predajo",
  "reason.onTime": "po času",
  "reason.abandoned": "zapuščeno",

  // --- analysis board ---
  "analysis.copyPgn": "Kopiraj PGN",
  "analysis.downloadPgn": "Prenesi .pgn",
  "analysis.copyFen": "Kopiraj FEN",
  "analysis.copied": "Kopirano ✓",
  "analysis.copyFailed": "Kopiranje ni uspelo",
  "analysis.saved": "Shranjeno ✓",
  "analysis.startingEngine": "Zaganjam motor…",
  "analysis.engineUnavailable": "Motor ni na voljo.",
  "analysis.done": "Analiza končana · globina {depth}",
  "analysis.thinking": "Razmišljam … globina {depth}",
  "analysis.bestLine": "Najboljša varianta · globina {depth}",
  "analysis.positions": "{done}/{total} položajev",
  "analysis.gameInProgress": "Partija v teku",
  "analysis.botGameGone": "Te partije z računalnikom ni več v zgodovini tega brskalnika.",
  "analysis.studyGone": "Tega študija ni več v knjižnici tega brskalnika.",
  "analysis.discardLine": "Zavrzi varianto",
  "analysis.backToGame": "Nazaj na partijo",
  "analysis.bestWas": "Najboljša je bila {move}",

  // --- review nav (transport controls) ---
  "review.start": "Na začetek",
  "review.startT": "Začetek (↑)",
  "review.prev": "Prejšnja poteza",
  "review.prevT": "Nazaj (←)",
  "review.next": "Naslednja poteza",
  "review.nextT": "Naprej (→)",
  "review.end": "Na konec",
  "review.endT": "Konec (↓)",
  "review.flip": "Obrni šahovnico",
  "review.play": "Predvajaj",
  "review.pause": "Premor",

  // --- shared components ---
  "qc.timeControl": "Časovni nadzor",
  "qc.yourColor": "Tvoja barva",
  "qc.rated": "Rangirano",
  "promo.promoteTo": "Spremeni v {role}",
  "promo.queen": "damo",
  "promo.rook": "trdnjavo",
  "promo.bishop": "lovca",
  "promo.knight": "skakača",
  "promo.cancel": "Prekliči",
  "mute.unmute": "Vklopi zvok",
  "mute.mute": "Izklopi zvok",
  "mute.soundOff": "Zvok izklopljen",
  "mute.soundOn": "Zvok vklopljen",
  "turnAlerts.label": "Partije in izzivi, ki te čakajo",
  "turnAlerts.yourMove": "na potezi si",
  "turnAlerts.waiting": "čakanje",
  "ready.challengesYou": "{who} te izziva na partijo.",
  "ready.rematch": "{who} želi revanšo.",
  "ready.accepted": "{who} je sprejel — tvoja partija je pripravljena.",
  "ready.waitingForYou": "{who} te čaka.",
  "ready.readyToPlay": "{who} je pripravljen na igro.",
  "ready.accept": "Sprejmi",
  "ready.join": "Pridruži se",
  "ready.play": "Igraj",
  "ready.wait": "Počakaj — trenutek",
  "ready.later": "Igraj pozneje",
  "ready.note": "Trenutek — takoj pridem.",
  "ready.askedWait": "te je prosil za trenutek",
  "ready.declinedChal": "je zavrnil tvoj izziv",
  "ready.wantsLater": "želi igrati pozneje",
  "ready.dismiss": "Zapri",
  "serverStatus.lost": "Povezava izgubljena — poskušam znova vzpostaviti…",

  // --- PGN result/termination lines ---
  "term.checkmate": "Mat",
  "term.resignation": "Predaja",
  "term.timeout": "Zmaga po času",
  "term.stalemate": "Pat",
  "term.insufficient": "Nezadostno gradivo",
  "term.repetition": "Trojna ponovitev",
  "term.repetitionShort": "Ponovitev",
  "term.drawClaimed": "Zahtevan remi",
  "term.fiftyMove": "Pravilo 50 potez",
  "term.draw": "Remi",
  "term.drawAgreed": "Dogovorjen remi",
  "term.abandonment": "Zapustitev",
  "term.returned": "Nadaljevano v Sporočilih",
  "pgn.whiteWins": "Beli zmaga",
  "pgn.blackWins": "Črni zmaga",
  "pgn.draw": "Remi",
  "pgn.game": "Partija",

  // --- admin ---
  "admin.tabMembers": "Člani",
  "admin.tabGroups": "Skupine",
  "admin.tabMessaging": "Sporočanje",
  "admin.tabDanger": "Nevarno območje",
  "admin.messagingTagline": "Stanje ponudnikov, trajna dostavna vrsta in neodvisna varnostna stikala.",
  "admin.messagingRefresh": "Osveži",
  "admin.messagingLoadFailed": "Stanja sporočanja ni bilo mogoče naložiti.",
  "admin.messagingQueueDepth": "v čakalni vrsti",
  "admin.messagingOldest": "starost najstarejšega",
  "admin.messagingDead": "mrtvo / pregled",
  "admin.messagingAge": "{seconds} s",
  "admin.messagingAlerts": "{count} operativnih opozoril zahteva pozornost.",
  "admin.messagingProviders": "Ponudniki",
  "admin.messagingProvider": "Ponudnik / račun",
  "admin.messagingState": "Stanje",
  "admin.messagingLastSuccess": "Zadnji uspeh",
  "admin.messagingLastError": "Razred zadnje napake",
  "admin.messagingEnable": "Omogoči",
  "admin.messagingDisable": "Onemogoči",
  "admin.messagingDisableQ": "Onemogočim {provider}/{account}? Nove poti in vhodna obdelava se ustavijo, čakajoče delo pa ostane vidno.",
  "admin.messagingControlFailed": "Varnostnega stikala ponudnika ni bilo mogoče spremeniti.",
  "admin.messagingNoProviders": "Noben ponudnik ni nastavljen.",
  "admin.messagingQueued": "Čakajoča obvestila",
  "admin.messagingDeadLetters": "Mrtva pisma in dvoumna pošiljanja",
  "admin.messagingKind": "Vrsta",
  "admin.messagingAttempts": "Poskusi",
  "admin.messagingNoneQueued": "Čakalna vrsta je prazna.",
  "admin.messagingNoneDead": "Ni mrtvih pisem ali dvoumnih pošiljanj.",
  "admin.messagingRetry": "Ponovi",
  "admin.messagingRetryQ": "Ponovim mrtvo pismo {id}? To je dovoljeno le za nedvoumno delo brez skrivnosti.",
  "admin.messagingRetryFailed": "Tega mrtvega pisma ni bilo mogoče ponoviti.",
  "admin.membersTagline": "Vsi na strani. Vloge, blokade in brisanje.",
  "admin.searchLabel": "Iskanje članov",
  "admin.searchPlaceholder": "Išči po imenu ali e-pošti…",
  "admin.allRoles": "Vse vloge",
  "admin.roleAdmins": "Skrbniki",
  "admin.rolePlayers": "Igralci",
  "admin.roleSuperuser": "Superuporabnik",
  "admin.anyStatus": "Vsi statusi",
  "admin.statusActive": "Aktivni",
  "admin.statusBanned": "Blokirani",
  "admin.thMember": "Član",
  "admin.thRole": "Vloga",
  "admin.thStatus": "Status",
  "admin.thInvitedBy": "Povabil",
  "admin.thActions": "Dejanja",
  "admin.roleAdmin": "skrbnik",
  "admin.rolePlayer": "igralec",
  "admin.roleSuper": "superuporabnik",
  "admin.badgeBanned": "blokiran",
  "admin.badgeActive": "aktiven",
  "admin.makeAdmin": "Povišaj v skrbnika",
  "admin.makePlayer": "Ponižaj v igralca",
  "admin.ban": "Blokiraj",
  "admin.unban": "Odblokiraj",
  "admin.delete": "Izbriši",
  "admin.deleteUserQ": "Trajno izbrišem {name}? Tega ni mogoče razveljaviti.",
  "admin.actionFailed": "Dejanje ni uspelo.",
  "admin.noMatchFilters": "Noben član ne ustreza tem filtrom.",
  "admin.groupsTagline": "Skupine določajo, koga sme igralec izzvati — unijo skupin, ki jim pripada.",
  "admin.groupsFailed": "Skupin ni bilo mogoče naložiti.",
  "admin.newGroup": "+ Nova skupina",
  "admin.name": "Ime",
  "admin.namePlaceholder": "npr. Torkov klub",
  "admin.kind": "Vrsta",
  "admin.kindStatic": "Statična (ročno izbrani člani)",
  "admin.kindLive": "Živa (pravilo)",
  "admin.kindBadgeStatic": "statična",
  "admin.kindBadgeLive": "živa",
  "admin.rule": "Pravilo",
  "admin.ruleDistance": "Oddaljenost povabila ≤ N",
  "admin.ruleRating": "Razpon ratinga",
  "admin.maxHops": "Največ korakov",
  "admin.speed": "Hitrost",
  "admin.min": "Min",
  "admin.max": "Maks",
  "admin.createGroup": "Ustvari skupino",
  "admin.creating": "Ustvarjam…",
  "admin.created": "Ustvarjeno.",
  "admin.nameNeeded": "Poimenuj skupino.",
  "admin.createFailed": "Skupine ni bilo mogoče ustvariti.",
  "admin.members": "Člani",
  "admin.handPicked": "ročno izbrani člani",
  "admin.deleteGroupQ": "Izbrišem skupino »{name}«?",
  "admin.deleteFailed": "Skupine ni bilo mogoče izbrisati.",
  "admin.loadingMembers": "Nalagam člane…",
  "admin.membersFailed": "Članov ni bilo mogoče naložiti.",
  "admin.noMembers": "Zaenkrat ni članov.",
  "admin.relativeNote": "Živo pravilo — članstvo se izračuna za vsakega igralca posebej. Prikazani so člani glede na tebe:",
  "admin.addMember": "Dodaj člana — vpiši ime ali e-pošto…",
  "admin.addMemberLabel": "Dodaj člana",
  "admin.noMatches": "Ni ustreznih članov.",
  "admin.addFailed": "Člana ni bilo mogoče dodati.",
  "admin.remove": "Odstrani {name}",
  "admin.delegation": "Pooblaščanje",
  "admin.delegationHelp": "Dovoli skrbnikom (ne le tebi), da podeljujejo in odvzemajo skrbniško vlogo.",
  "admin.delegationOn": "Skrbniki zdaj lahko pooblaščajo.",
  "admin.delegationOff": "Pooblaščanje onemogočeno.",
  "admin.resetDb": "Ponastavi bazo",
  "admin.resetHelp": "Izbriše vse partije, izzive, ratinge, skupine in člane — <strong>ostaneš samo ti</strong>. Samo za razvoj; ni mogoče razveljaviti.",
  "admin.resetPlaceholder": "vpiši RESET za odklep",
  "admin.wipeQ": "Res izbrišem bazo? To odstrani vse partije, uporabnike in povabila.",
  "admin.resetting": "Ponastavljam…",
  "admin.resetDone": "Baza ponastavljena. Nalagam znova…",
  "admin.resetFailed": "Ponastavitev ni uspela.",
  "admin.membership": "Članstvo",
  "admin.membershipOpen": "Sprejemaj prošnje za včlanitev (na prijavni strani prikaže »Postani član«).",
  "admin.membershipNotify": "Prošnje pošiljaj na",
  "admin.applicationsOpen": "Prošnje so odprte.",
  "admin.applicationsClosed": "Prošnje so zaprte.",
  "game.unavailable": "Partija trenutno ni na voljo. Prikazan je zadnji shranjeni položaj.",
  "game.withdrawConfirmation": "Umakni potrditev",
  "game.playedInMessages": "Odigrano v Sporočilih",
  "game.onlineBoundary": "Tu se začne spletna igra",
  "game.pausedInterruption": "Partija je po prekinitvi začasno ustavljena. Nadaljuje se, ko sta pripravljena oba igralca.",
  "game.pausedConsent": "Partija je začasno ustavljena. Nadaljuje se, ko sta pripravljena oba igralca.",
  "game.savedClocks": "Uri uporabljata zadnji shranjeni preostali čas.",
  "game.readyExpires": "Tvoja potrditev poteče čez {seconds} s.",
  "game.firstMoveDeadline": "Prvo potezo odigraj v {seconds} s.",
  "game.untimedAbsence": "Brez ure · Brez ratinga. Partija se začasno ustavi, če je kateri od igralcev odsoten dve minuti.",
  "game.awayCountdown": "{side} je videti odsoten. Partija se začasno ustavi čez {seconds} s, če se oba igralca ne vrneta.",
  "game.importedCount": "Število polpotez iz Sporočil: {count}.",
  "game.unfinished": "Partija se ni zaključila",
  "game.untimedTerms": "Brez ure · Brez ratinga",
  "game.pauseGame": "Začasno ustavi partijo",
  "game.resumeReady": "Pripravljen na nadaljevanje",
  "command.stale": "Partija se je spremenila. Preglej trenutni položaj in poskusi znova.",
  "command.illegal": "Ta poteza v tem položaju ni dovoljena.",
  "command.capacity": "Vse spletne šahovnice so zasedene. Poskusi kmalu znova. Oba igralca morata znova potrditi.",
  "command.busy": "Eden od igralcev že igra aktivno partijo. Oba igralca morata znova potrditi.",
  "command.closed": "Nove spletne partije so začasno onemogočene. Poskusi pozneje.",
  "command.rematch": "Povratna partija je pripravljena. Odpri shranjeno partijo.",
  "command.timeControl": "Za novo partijo izberi časovno kontrolo.",
  "command.waiting": "Čakamo na potrditev drugega igralca.",
  "command.finished": "Ta partija je zaključena.",
  "command.paused": "Partija je začasno ustavljena. Nadaljuje se, ko sta pripravljena oba igralca.",
  "command.forbidden": "Ta račun ne more spreminjati te partije.",
  "command.turn": "Na potezi je drugi igralec.",
  "command.time": "Drugemu igralcu čas še ni potekel.",
  "command.claim": "Zmage še ni mogoče zahtevati.",
  "command.wait": "Pred ponovnim poskusom malo počakaj.",
  "command.drawPending": "Tvoja ponudba remija čaka na odgovor.",
  "command.noDraw": "Ni čakajoče ponudbe remija.",
  "command.returned": "Ta partija se nadaljuje v Sporočilih.",
  "command.returnRefused": "Pred novim predlogom odigraj potezo.",
  "command.returnPending": "Tvoj predlog čaka na odgovor.",
  "command.noReturn": "Ni čakajočega predloga.",
  "command.notAMatch": "V Sporočila se lahko vrne le partija, ki je prišla od tam.",
  "command.failed": "Dejanja ni bilo mogoče dokončati. Preglej trenutno partijo in poskusi znova.",
  "clock.legend": "Ura",
  "clock.untimed": "Brez ure",
  "clock.unrated": "brez ratinga",
  "clock.terms": "{clock} · {speed} · brez ratinga",
  "clock.termsUntimed": "Brez ure · brez ratinga",
  "clock.pickHint": "Prijatelj vidi uro, preden se pridruži.",
  "hs.back": "Nazaj",
  "session.ended": "Prejšnja seja brskalnika se je končala. Za nadaljevanje začnite kot nov gost ali obnovite partije, shranjene z e-pošto. Nov gost ne more obnoviti neshranjenih partij iz prejšnje seje.",
  "session.newGuest": "Začni kot nov gost",
  "session.recoverSaved": "Obnovi shranjene partije",
  "hs.playHere": "Igraj tukaj",
  "hs.illPlay": "Igram",
  "hs.startGame": "Začni partijo",
  "hs.imHere": "Tukaj sem",
  "hs.waiting": "Čakam …",
  "hs.notNow": "Ne zdaj",
  "hs.holdOn": "Počakaj",
  "hs.sendToFriend": "Pošlji prijatelju",
  "hs.sideWhite": "Igraš z belimi.",
  "hs.sideBlack": "Igraš s črnimi.",
  "hs.friendHere": "{name} je tukaj.",
  "hs.friendNotYet": "Prijatelj se še ni pridružil.",
  "hs.invitedBy": "{name} te vabi na partijo.",
  "hs.offerFrom": "{name} predlaga nadaljevanje v živo.",
  "hs.hostOpening": "Čakamo, da prijatelj odpre šahovnico.",
  "hs.continueHere": "Nadaljuj to partijo v živo.",
  "hs.checkFriend": "Preveri, ali je to tvoj prijatelj, in začni.",
  "hs.hostStarts": "{name} začne partijo. Pusti to stran odprto.",
  "hs.youreIn": "Zraven si. Partija se začne, ko bo tukaj tudi {name}.",
  "hs.otherReady": "{name} je pripravljen.",
  "hs.pressAgain": "Ko se vrneš k šahovnici, pritisni Tukaj sem.",
  "hs.shareHint": "Pošlji povezavo prijatelju in pusti to stran odprto.",
  "hs.inMessages": "Prijatelj lahko sprejme v vajini igri v Sporočilih. Pusti to stran odprto.",
  "hs.messagesEnds": "Nova poteza v Sporočilih konča to ponudbo.",
  "hs.keepMessages": "Lahko pa igrata naprej v Sporočilih.",
  "hs.expires": "Poteče {when}.",
  "hs.noApp": "Brez prijave in brez aplikacije.",
  "hs.link": "Povezava do vabila",
  "hs.copied": "Povezava je kopirana.",
  "hs.copyFallback": "Označi in kopiraj povezavo do vabila spodaj.",
  "hs.cancelConfirm": "Prekličem vabilo? Prijatelj bo potreboval novo povezavo.",
  "hs.expired": "Vabilo je poteklo.",
  "hs.cancelled": "Vabilo je preklicano.",
  "hs.newInvitation": "Ustvari novo vabilo",
  "hs.opening": "Odpiram partijo …",
  "hs.retryNote": "Prejšnje dejanje bo preverjeno ob ponovnem poskusu.",
  "play.studyLine": "Medtem ko čakaš na partijo, se v Študiju nauči kakšno otvoritev.",
  "play.studyLink": "Odpri Študij",
  ...boardsSl,
};
